import FileService from '../../../../services/FileService';
import { listarKmzNsir } from '../../../../services/kmzMatriz';
import { normalizarListaKmz, sufixoArquivoKmz, TIPO_INSPECAO } from './kmzAnexoAcoes';

function salvarArquivo(dados, nome) {
  const blob = dados instanceof Blob
    ? dados
    : new Blob([dados], { type: 'application/vnd.google-earth.kmz' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 60000);
}

async function urlFresca(nsirId, tipo, urlAtual) {
  if (!nsirId || !tipo) return urlAtual || '';
  try {
    const consulta = await listarKmzNsir(nsirId, tipo);
    const fresco = normalizarListaKmz(consulta && consulta.data).find((entry) => entry.tipo === tipo);
    return (fresco && fresco.url) || urlAtual || '';
  } catch (error) {
    return urlAtual || '';
  }
}

function nomeKmz(base, tipo) {
  const limpo = String(base || 'KMZ').replace(/[<>:"/\\|?*]/g, ' ').replace(/\s+/g, ' ').trim() || 'KMZ';
  const sufixo = sufixoArquivoKmz(tipo);
  if (sufixo) return `${limpo}_${sufixo}.kmz`;
  return `${limpo}.kmz`;
}

export async function baixarParaGoogleEarth({ itens, nsirId, arquivoLocal, nomeBase, arquivos }) {
  const lista = Array.isArray(itens) ? itens : [];
  const cache = arquivos || {};
  const pendentes = [];
  let baixou = 0;
  lista.forEach((item) => {
    if (!item) return;
    const local = item.tipo === TIPO_INSPECAO && !item.url && arquivoLocal;
    const blob = cache[item.tipo] || (local ? arquivoLocal : null);
    if (!blob) {
      pendentes.push(item);
      return;
    }
    salvarArquivo(blob, nomeKmz(nomeBase, item.tipo));
    baixou += 1;
  });
  const falhas = [];
  for (let i = 0; i < pendentes.length; i += 1) {
    const item = pendentes[i];
    try {
      const url = await urlFresca(nsirId, item.tipo, item.url);
      if (!url) {
        falhas.push(item.tipo);
        continue;
      }
      const response = await FileService.getFile(url);
      salvarArquivo(response && response.data, nomeKmz(nomeBase, item.tipo));
      baixou += 1;
    } catch (error) {
      falhas.push(item.tipo);
    }
  }
  if (!baixou) throw new Error('Não há KMZ para baixar.');
  if (falhas.length) throw new Error('Um dos KMZ não pôde ser baixado.');
}
